<template>
  <div>
    <div>
      <el-table
        ref="table"
        :data="getModifyLogListArr"
        height="150"
        v-loading="logLoding"
        header-row-class-name="table-header-row"
        border
      >
        <template slot="empty">
          <Empty />
        </template>
        <el-table-column label="Modifer" min-width="100">
          <template v-slot="{ row }">
            <div v-if="row.operation">{{ row.operation }}</div>
          </template>
        </el-table-column>
        <el-table-column label="Time" min-width="130">
          <template v-slot="{ row }">
            <div v-if="row.operationTime">{{ formatUtc(row.operationTime) }}</div>
          </template>
        </el-table-column>
        <el-table-column label="Remark" min-width="500">
          <template v-slot="{ row }">
            <div v-if="row.operationAfter == -1">-</div>
            <div v-else>{{ row.operationAfter }}</div>
          </template>
        </el-table-column>
        <el-table-column label="Pin" min-width="100">
          <template v-slot="{ row }">
            <el-switch
              v-model="row.pin"
              active-color="#13ce66"
              inactive-color="#ff4949"
              @change="handleSwitchChange(row.id)"
            ></el-switch>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import Empty from "@/components/empty/index";
import { pinCheck } from "@/api/memberDetail";
export default {
  components: {
    Empty
  },
  props: {
    getModifyLogListArr: {
      type: Array,
      default: () => []
    },
    logLoding: {
      type: Boolean
    }
  },
  data() {
    return {
      tableHeight: window.innerHeight
    };
  },
  methods: {
    feachType(val) {
      if (val == 0) {
        return "User Limit";
      }
      if (val == 1 || val == 4) {
        return "Label";
      }
      if (val == 2) {
        return "Status";
      }
      if (val == 3) {
        return "Alert";
      }
      if (val == 5) {
        return "Level";
      }
      if (val == 6) {
        return "oddsLevel";
      }
      if (val == 7) {
        return "selfRisk";
      }
      if (val == 8) {
        return "check";
      }
    },
    async handleSwitchChange(val) {
      try {
        const response = await pinCheck({ id: val });
        console.log(response, "response");
        this.$emit("api-call-success", response);
      } catch (error) {
        this.$emit("api-call-success", response);
        console.error("API 调用失败", error);
      }
    },
    formatUtc(time) {
      if(!time) return "";
      return this.$moment(+time).format("YYYY-MM-DD HH:mm:ss");
    }
  },
  mounted() {
    //this.getList();
    let self = this;
    self.tableHeight = window.innerHeight - self.$refs.table.$el.offsetTop - 94;
    window.onresize = function() {
      self.tableHeight =
        window.innerHeight - self.$refs.table.$el.offsetTop - 94;
    };
  }
};
</script>

<style lang="scss" scoped></style>
